import { useTranslation } from 'react-i18next';

/**
 * Language toggle - "🇧🇷 PT | 🇺🇸 EN"
 * Use `variant="dark"` on dark/black backgrounds and `variant="light"` on light backgrounds.
 */
export default function LanguageToggle({ variant = 'light', className = '' }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'pt').slice(0, 2);

  const setLang = (lng) => {
    if (current === lng) return;
    i18n.changeLanguage(lng);
    try { localStorage.setItem('tk-lang', lng); } catch { /* ignore */ }
  };

  const isDark = variant === 'dark';
  const base = isDark
    ? 'border-white/20 bg-white/5 text-white/85'
    : 'border-[#E6E2D8] bg-white text-[#1A1A1A]';
  const activeCls = isDark
    ? 'bg-white text-black'
    : 'bg-black text-white';
  const inactiveCls = isDark
    ? 'hover:bg-white/10'
    : 'hover:bg-[#F5F1E8] text-[#73706A]';

  return (
    <div
      className={`inline-flex items-center gap-1 rounded-full border p-0.5 text-xs font-semibold ${base} ${className}`}
      role="group"
      aria-label="Language"
      data-testid="lang-toggle"
    >
      <button
        type="button"
        onClick={() => setLang('pt')}
        className={`px-2.5 py-1 rounded-full flex items-center gap-1 transition-colors ${current === 'pt' ? activeCls : inactiveCls}`}
        aria-pressed={current === 'pt'}
        data-testid="lang-toggle-pt"
      >
        <span aria-hidden="true">🇧🇷</span>
        <span>PT</span>
      </button>
      <button
        type="button"
        onClick={() => setLang('en')}
        className={`px-2.5 py-1 rounded-full flex items-center gap-1 transition-colors ${current === 'en' ? activeCls : inactiveCls}`}
        aria-pressed={current === 'en'}
        data-testid="lang-toggle-en"
      >
        <span aria-hidden="true">🇺🇸</span>
        <span>EN</span>
      </button>
    </div>
  );
}
